import { useCallback } from 'react';

import { setReferralCode } from 'modules/auth/store/authSlice';
import { useAppDispatch } from 'store/useAppDispatch';
import { useAuth } from 'modules/auth/hooks/useAuth';

export const useSavedReferralCode = () => {
  const { referralCode: savedReferralCode } = useAuth();

  const dispatch = useAppDispatch();

  const handleRemoveSavedReferralCode = useCallback(() => {
    dispatch(setReferralCode(undefined));
  }, [dispatch]);

  return { handleRemoveSavedReferralCode, savedReferralCode };
};
